var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"fs-14 p-2",attrs:{"variant":_vm.copy.status == 1 ? 'success' : 'danger'}},[(_vm.load)?_c('b-spinner'):_c('span',[_vm._v(" "+_vm._s(_vm.copy.status == 1 ? 'Ativa' : 'Inativa')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }